export const LOADING = 'listFollowers.LOADING';
export const LOADED = 'listFollowers.LOADED';